import React from "react";
import { Routes, Route } from "react-router-dom";
import PrivateRoute from '../components/router/privateRoute';
import Login from "../views/login";
import Sureler from "../views/sureler";
import Ayetler from "../views/ayetler";
import EsmaulHusna from "../views/esmaulHusna";




const RoutePages = (props) => {
  return (
    <Routes>
      <Route exact path='/' element={<PrivateRoute />}>
      <Route index path="/Sureler" element={<Sureler />} />
      <Route index path="/Ayetler" element={<Ayetler />} />
      <Route index path="/Esmaul-Husna" element={<EsmaulHusna />} />
      </Route>

      <Route index path="/Login"  element={<Login />} />
    </Routes>
  )
}

export default RoutePages;
